// JSON-LD structured data for SEO and AEO (Organization, WebSite on all pages)
const BASE_URL = "https://www.kolanut.ai";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Kolanut AI",
  url: BASE_URL,
  logo: `${BASE_URL}/og-image.png`,
  description: "Kolanut AI is the AI Marketing Co-Pilot for Solo Pros & SMBs — Hyper Personalized Campaigns, Cross Platform Ads Optimization, and Tools and Widgets run automatically while you focus on clients.",
  sameAs: [
    "https://instagram.com/kolanut.ai",
    "https://m.me/kolanut.ai",
    "https://wa.me/19848886717",
  ],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Kolanut AI",
  url: BASE_URL,
  description: "Customer Growth on Autopilot. AI-powered marketing automation for solo pros and SMBs.",
  publisher: { "@id": `${BASE_URL}/#organization` },
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: `${BASE_URL}/blog?q={search_term_string}` },
    "query-input": "required name=search_term_string",
  },
};

function JsonLd() {
  // Organization with @id for WebSite publisher reference
  const organizationWithId = {
    ...organizationSchema,
    "@id": `${BASE_URL}/#organization`,
  };

  const scripts = [
    { id: "jsonld-organization", data: organizationWithId },
    { id: "jsonld-website", data: websiteSchema },
  ];

  return (
    <>
      {scripts.map(({ id, data }) => (
        <script
          key={id}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
      ))}
    </>
  );
}

export default JsonLd;
